import AuthRoute from './auth/Auth.Route';
import RoutesMap from '../route_control/RouteControl';
import { AddStudent } from '../pages/master';

const PublicRoute = () => {
    return [
        // {
        //     path: RoutesMap.ADD_STUDENT.path,
        //     element: <AddStudent />
        // },
        {
            path: RoutesMap.STUDENT_REGISTRATION.path,
            element: <AddStudent />
        },
        ...AuthRoute()
    ]
}

export default PublicRoute;
